import React from 'react';

import HeaderfulContainer from 'src/components/molecules/headerfulContainer';
import CheckBox from 'src/components/atoms/checkbox';
import PrinterStationStatus from '../../molecules/printerStationStatus';
import {
  PrinterStationConfigPcIdInput,
  PrinterStationConfigWrapper,
} from './styles';

interface PrinterStationConfigProps {
  isPrinterComputer: boolean;
  pcId: number;
  onTogglePrinterComputer: (value: boolean) => void;
  onPcIdChange: (id: number) => void;
  isPrinterDeviceAvailable: boolean;
}

const PrinterStationConfig: React.FC<PrinterStationConfigProps> = ({
  isPrinterComputer,
  pcId,
  onTogglePrinterComputer,
  onPcIdChange,
  isPrinterDeviceAvailable,
}) => {
  const handlePcIdChange = (event: any) => {
    const {
      target: { value },
    } = event;
    if (/^[0-9]*$/.test(value)) {
      onPcIdChange(Number(value));
    }
  };

  const handleToggle = () => {
    onTogglePrinterComputer(!isPrinterComputer);
  };

  return (
    <PrinterStationConfigWrapper>
      <HeaderfulContainer title="Configuração de Impressão">
        <PrinterStationConfigPcIdInput
          label="Informe o número do computador"
          onChange={handlePcIdChange}
          value={String(pcId)}
        />
        <CheckBox
          selected={isPrinterComputer}
          onSelect={handleToggle}
          text="Receber pedidos de impressão de outros computadores"
        />
        <PrinterStationStatus available={isPrinterDeviceAvailable} />
      </HeaderfulContainer>
    </PrinterStationConfigWrapper>
  );
};

export default PrinterStationConfig;
